module.exports = __webpack_public_path__ + "media/images/Igazsagugyi_Miniszterium-47ea54d112717f20822551906ed2a9e5.png";